import { memo } from 'react';
import { FacebookEmbed, XEmbed, InstagramEmbed, YouTubeEmbed } from 'react-social-media-embed';

import type { LbPart } from '../../../types';
import { SocialType } from '../../../types';

import './styles.scss';

const Social = ({ part: { data } }: { part: LbPart }) => (
  <>
    {data.Type === SocialType.FACEBOOK && <FacebookEmbed url={data.Url} />}
    {data.Type === SocialType.TWITTER && <XEmbed url={data.Url} />}
    {data.Type === SocialType.INSTAGRAM && <InstagramEmbed url={data.Url} />}
    {data.Type === SocialType.YOUTUBE && (
      <YouTubeEmbed
        youTubeProps={{
          loading: 'lazy',
          iframeClassName: 'lb-youtube-iframe',
        }}
        url={data.Url}
      />
    )}
  </>
);

export default memo(Social);
